import { CorpusApprovalEnum, PaymentStatusEnum, PayMode } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class ExpensesDTO {
    @ApiProperty()
    expensesId:number;
    @ApiProperty()
    expensesAgainst:string;
    @ApiProperty()
    expensesCategoryId:number;
    @ApiProperty()
    paymentMode:string;
    @ApiProperty()
    refrenceNo:string;
    @ApiProperty()
    paidToEmployeeOrVendor:string;
    @ApiProperty()
    employeeName:string;
    @ApiProperty()
    paymentStatus:PaymentStatusEnum;
    @ApiProperty()
    amount:number;
    @ApiProperty()
    corpusApproval:CorpusApprovalEnum;
    @ApiProperty()
    approvedBy:string;
    @ApiProperty()
    remarks:string;
    @ApiProperty()
    isActive:boolean;
    @ApiProperty()
    createdAt: Date;
    @ApiProperty()
    createdUser: string | null;
    @ApiProperty()
    updatedAt: Date;
    @ApiProperty()
    updatedUser: string | null;
    @ApiProperty()
    versionFlag: number;
}